
<div class="d-flex justify-content-center">  
  <button class="btn btn--warning m-0 note-page" (click)="popconfirmdeletenote()" type="submit">
    <span><i class="fa fa-trash"></i> Delete Page</span>
  </button>

  <button class="btn m-0 note-page" (click)="addPage()" type="submit">
    <span><i class="fa fa-plus"></i> Add Next Page</span>
  </button>
</div>
<div class="d-flex justify-content-center mt-2">  
  <button class="btn m-0 note-page" (click)="previousPage()" type="submit" [disabled]="currentPage == 1">
    <span><i class="fa fa-angle-left"></i> Previous</span>
  </button>
  <button class="btn m-0 note-page" (click)="nextPage()" type="submit" [disabled]="this.currentPage == this.lessonnote.length">
    <span>Next <i class="fa fa-angle-right"></i></span>
  </button>
</div>
<div class="fieldset fieldset--note mt-4">
  <label for="title" class="legend">Note Title </label>
  <input type="text" name="title" class="text-field" [(ngModel)]="title">
</div>
<div class="fieldset fieldset--note">
  <quill-editor placeholder="Enter Lesson Note" classes="ql-container--lg" #editor></quill-editor>
</div>

<div class="d-flex justify-content-center flex-wrap gap-1.5" style="margin-top: 5vh;">
  <button class="btn m-0" (click)="saveNotes()" type="submit">Save</button>
  <button class="btn btn--warning m-0" (click)="goback()" type="submit">Cancel</button>
</div>

<div class="modal fade" #mediaModal tabindex="-1" role="dialog" aria-labelledby="mediaModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="mediaModalLabel">Select Media</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-module-media-library [classid]="this.classid" [enableselect]="true"
          (mediaSelected)="mediaSelected($event)"></app-module-media-library>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn--warning" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" #externalMediaModal tabindex="-1" role="dialog" aria-labelledby="externalMediaModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="externalMediaModalLabel">Select Media</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-add-external-media #addExternalMediaComponent></app-add-external-media>
      </div>
      <div class="modal-footer justify-content-center gap-1.5">
        <button type="button" class="btn m-0" (click)="externalMediaSelected()"
          [disabled]="!addExternalMediaComponent.mediaurl.trim()">Ok</button>
        <button type="button" class="btn btn--warning m-0" (click)="closeExternalMediaModal()">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" #urlLinkModal id="urlLinkModal" tabindex="-1" role="dialog"
  aria-labelledby="urlLinkModal" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="urlLinkModal">Insert Link</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="fieldset w-100 mb-3">
          <label class="legend" for="mediaurl">Enter Placeholder <span class="requiredfield">*</span></label>
          <input type="text" name="title" id="mediaurl" class="text-field" [(ngModel)]="linkPlaceholder" required="required">
        </div>
        <div class="fieldset w-100 mb-0">
          <label class="legend" for="mediaurl">Enter URL <span class="requiredfield">*</span></label>
          <input type="text" name="title" id="mediaurl" class="text-field" [(ngModel)]="linkUrl" required="required">
        </div>
      </div>
      <div class="modal-footer justify-content-center gap-1.5">
        <button type="button" class="btn m-0" (click)="insertLinkUrl()"
          [disabled]="!linkUrl.trim() && !linkPlaceholder.trim()">Ok</button>
        <button type="button" class="btn btn--warning m-0" (click)="closeLink()">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="deleteLessonnote" data-keyboard="false" data-backdrop="static" aria-hidden="true"
  role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Delete Note</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <p class="text-center pb-2">Are you sure you want to delete this page?</p>
        <div class="d-flex justify-content-center flex-wrap gap-1.5">
          <button type="submit" class="btn btn--danger m-0" (click)="preDeletePage()">Delete</button>
          <button type="button" class="btn m-0" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
